import axios from 'axios'

export const documentTypes = {
    state: {
        status: 'init',
        documentTypes: []
    },
    mutations: {
        SET_DOCUMENTTYPES_STATUS(state, status) {
            state.status = status
        },
        SET_DOCUMENTTYPES(state, documentTypes){
            state.documentTypes = documentTypes
        }
    },
    actions: {
        setDocumentTypes({ commit }, documentTypes){
            commit('SET_DOCUMENTTYPES', documentTypes)
        },
        fetchDocumentTypes({ commit }){
            commit('SET_DOCUMENTTYPES_STATUS', 'loading')
            return axios.get(`${process.env.VUE_APP_API}api/advices/document-types`)
            .then((response) => {
                commit('SET_DOCUMENTTYPES', Object.keys(response.data.data).map(item => ({
                    id: item,
                    name: response.data.data[item]
                })))
                commit('SET_DOCUMENTTYPES_STATUS', 'idle')
            }).catch(e => {
                console.log(e);
            })
        }
    },
    getters : {
        documentTypesStatus: (state) => {
            return state.status
        },
        documentTypes: (state) => {
            return state.documentTypes
        }
    }
}
